
import Typography from "@mui/joy/Typography";
import Box from "@mui/joy/Box";
import Breadcrumbs from "@mui/joy/Breadcrumbs";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import Link from "@mui/joy/Link";
import {Link as RouterLink} from "react-router-dom";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import { Textarea } from "@mui/joy";
import { useEffect, useState } from "react";
import { apiClient } from "../../../../lib/api/api-client";

export default function SimpleFormQuestionUrlPage() {
  const [url, setUrl] = useState<string>()
  const client = apiClient()

  useEffect(() => {
    initPage()
  }, [])

  const initPage = async () => {
    const resp = await client.GET(
      '/partner/simple-form/question-url'
    )
    
    if (resp.error) {
      alert('오류 발생')
      return
    }
    
    setUrl(resp.data.url)
  }


  return (
    <>
      <Box sx={{display: 'flex', alignItems: 'center'}}>
        <Breadcrumbs
          size="sm"
          aria-label="breadcrumbs"
          separator={<ChevronRightRoundedIcon fontSize="small"/>}
          sx={{pl: 0}}
        >
          <Link
            underline="none"
            color="neutral"
            component={RouterLink}
            to="/console"
            aria-label="Home"
          >
            <HomeRoundedIcon/>
          </Link>
          <Typography fontWeight={500} fontSize={12}>
            간편문진
          </Typography>
          <Typography color="primary" fontWeight={500} fontSize={12}>
            URL 확인
          </Typography>
        </Breadcrumbs>
      </Box>

      <Box
        sx={{
          display: 'flex',
          mb: 1,
          gap: 1,
          flexDirection: {xs: 'column', sm: 'row'},
          alignItems: {xs: 'start', sm: 'center'},
          flexWrap: 'wrap',
          justifyContent: 'space-between',
        }}
      >

        <Typography level="h2" component="h1">
        URL 확인
        </Typography>


      </Box>

      <Textarea value={url} onClick={(ev) => (ev.target as HTMLTextAreaElement).select()} />
    </>
  );
}